import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { CommonVariable } from "src/app/app.constants";
import { IonicModule } from "@ionic/angular";
import { AsyncPipe } from "@angular/common";
import { DisplayCurrencyPipe } from "../../../pipe/display-currency.pipe";
@Component({
    selector: "app-cashout-success",
    templateUrl: "./cashout-success.component.html",
    styleUrls: ["./cashout-success.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        AsyncPipe,
        DisplayCurrencyPipe,
        TranslatePipe],
})
export class CashoutSuccessComponent implements OnInit {
  type = "";
  balance$ = this.authService.userCurrentBalance$;
  preferredCurrency: string = CommonVariable.preferredCurrency
  currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  constructor(
    private dialogRef: MatDialogRef<CashoutSuccessComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private authService: AuthService,
    public translate: TranslateService
  ) {
    this.authService?.selectedlanguage$?.subscribe((l) => {
      if (l) {
        translate.use(l ? l : "en");
      }
    }, err => { return (err) });

    this.authService.userDetails$?.subscribe((user: any) => {
      this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
      this.authService.getCurrencyList$?.subscribe((data: any) => {
        const CurrencyDetails = data?.details?.find((x: any) => x?.currency_code === this.preferredCurrency);
        this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
      });
    },
      (err) => {
        return err;
      });

    this.type = data?.type;
  }

  ngOnInit() { }

  closeDialog() {
    this.dialogRef.close();
  }

  closeAndRedirect(type: string) {
    this.dialogRef.close(type);
  }
}
